import { getApiDomain } from "../../../utils";
import { ProductInfo } from "../types";

export async function getProductInfo(
    productId: string,
    signal?: AbortSignal
): Promise<ProductInfo> {
    const csrfElement = document.querySelector("[data-csrf]");
    const csrf = csrfElement?.getAttribute("data-csrf");

    if (!csrf) {
        throw new Error("CSRF token element [data-csrf] is missing or empty");
    }

    const response = await fetch(`${getApiDomain()}/features-api/v2/products/${productId}`, {
        signal,
        headers: {
            "content-type": "application/json",
            "x-csrf-token": csrf
        }
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    const body = await response.json();
    return body.response.data as ProductInfo;
}
